import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import ListHeader from "./ListHeader";

const ROWS = 4;

interface Props {
  withToolbar?: boolean;
}

export default function ListSkeleton({ withToolbar = false }: Props) {
  const rows = Array.from(Array(ROWS).keys());

  return (
    <div data-testid="malware-list_loading">
      {withToolbar && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gridGap={16}
          marginBottom={2}
        >
          <Skeleton variant="rect" width={280} height={40} />
          <Skeleton variant="rect" width={420} height={40} />
        </Box>
      )}
      <TableContainer component={Paper}>
        <Table size="small">
          <ListHeader />
          <TableBody>
            {rows.map(row => (
              <TableRow key={row} style={{ height: 64 }}>
                <TableCell style={{ width: 28, paddingRight: 0 }} />
                <TableCell>
                  <Box display="flex" alignItems="center" gridGap={12}>
                    <Skeleton variant="rect" width={36} height={36} />
                    <Box>
                      <Skeleton width={220} height={18} />
                      <Skeleton width={140} height={14} />
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Skeleton width={90} height={18} />
                  <Skeleton width={110} height={14} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rect" width={72} height={20} />
                </TableCell>
                <TableCell align="right" style={{ width: "1%" }}>
                  <Skeleton variant="rect" width={110} height={30} />
                </TableCell>
                <TableCell style={{ width: 40 }}>
                  <Skeleton variant="circle" width={24} height={24} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
